import React, {useState, useEffect} from 'react';
import {axios} from '@js/axios.js';
import {createURL} from '@js/utils';
import {hot} from 'react-hot-loader/root';

export const getSessionInfo = async() => {
  const {data} = await axios.get('/actions/users/session-info');

  return data;
};

const Comp = (props) => {
  const [loggedIn, setLoggedIn] = useState(null);
  const [username, setUsername] = useState(null);
  const {loginLink} = props;

  useEffect(() => {
    getSessionInfo().then(({isGuest, username}) => {
      setLoggedIn(!isGuest);
      setUsername(username);
    });
  });

  const {loginURL, logoutURL} = props;

  return (
    <div>
      { loggedIn ? (
        <div className='uk-inline'>
          <a href={createURL('members/profile')} aria-label='Profile' className='Avatar'>
            {username && username.slice(0, 1).toUpperCase()}
          </a>
          <div className='uk-tooltip uk-margin-remove uk-background-muted uk-box-shadow-small uk-text-center' data-uk-drop='animation: uk-animation-scale-up; pos: bottom-right; duration: 100; delay-hide: 0; offset: 8'>
            <a href={createURL('members/profile')}>
              <span data-uk-icon='icon: custom-account; ratio: .7' className='uk-margin-small-right'></span>
              <span>{username}</span>
            </a>
            <span className='uk-text-meta uk-padding-small'>|</span>
            <a href={logoutURL}>
              <span>Log Out</span>
            </a>
          </div>
        </div>
      ) : (
        <a
          href={loginURL}
          data-uk-icon='icon: custom-account; ratio: .9'
          data-uk-tooltip='title: Log In; pos: bottom'
          aria-label='Log In'></a>
      )}
    </div>
  );
};

export default hot(Comp);
